import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
let infos = class infos extends Vue {
    constructor() {
        super(...arguments);
        this.todoNumber = "";
        this.finishNumber = "";
        this.historyNumber = "";
    }
    goto(type) {
        location.replace("/workflow-center/" + type);
    }
    get themeColor() {
        return this.$store.state.themeColor || "blue";
    }
    get isHomePage() {
        return this.$route.path === "/workbench-center/workbench";
    }
    getImg(number) {
        let themeColor = this.themeColor;
        // eslint-disable-next-line import/no-dynamic-require
        return require(`./images/${themeColor}${number}.svg`) || "";
    }
    getTodoNum(params) {
        return axios.post("/api/homepageext/list_workitem", params);
    }
    get appCode() {
        return this.$route.params.appCode;
    }
    getTodoNumber() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = {
                appCode: this.appCode ? this.appCode : "",
            };
            const res = yield this.getTodoNum(params);
            if (res.errcode === 0) {
                let content = res.data;
                content.forEach((item) => {
                    if (item.type === "todo") {
                        this.todoNumber = item.count;
                    }
                    if (item.type === "draft") {
                        this.finishNumber = item.count;
                    }
                    if (item.type === "history") {
                        this.historyNumber = item.count;
                    }
                });
            }
        });
    }
    created() {
        this.getTodoNumber();
    }
};
tslib_1.__decorate([
    Prop({
        default: () => {
            return {};
        },
    })
], infos.prototype, "infoData", void 0);
infos = tslib_1.__decorate([
    Component({
        name: "infos",
        components: {},
    })
], infos);
export default infos;
